<template>
  <b-overlay :show="loading" opacity="0.8">
    <validation-observer ref="form_ref" #default="{ invalid }">
      <b-card class="rounded-lg">
        <template #header>
          <div class="d-flex justify-content-between align-items-center w-100 pb-1" style="border-bottom: 2px solid rgb(238, 238, 238);">
            <h4 class="text-dark m-0">
              Presenting Complaint History
            </h4>

            <b-button v-if="can('consultations:CanUpdate')" class="float-right" variant="outline-primary" :disabled="invalid || presenting_complaint_history === consultationData.presenting_complaint_history" @click="onUpdate">
              Update
            </b-button>
          </div>
        </template>

        <validation-observer #default="{ handleSubmit }" ref="update_modal_form">
          <b-form @submit.prevent="handleSubmit(onUpdate)">
            <div class="no-body">
              <validation-provider #default="validationContext" name="" rules="">
                <b-form-group label="">
                  <b-form-textarea
                    id="presenting_complaint_history"
                    v-model="presenting_complaint_history"
                    rows="15"
                    :disabled="disableForm"
                    :state="getValidationState(validationContext)"
                  />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </div>

            <b-button v-if="can('consultations:CanUpdate')" class="float-right" variant="outline-primary" :disabled="invalid || presenting_complaint_history === consultationData.presenting_complaint_history" @click="onUpdate">
              Update
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
    </validation-observer>
  </b-overlay>
</template>

<script>
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BOverlay,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormTextarea,
  BFormInvalidFeedback,
} from 'bootstrap-vue'

import { get } from 'lodash';
import { heightTransition } from '@core/mixins/ui/transition';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BBadge,
    BAlert,
    BAvatar,
    BButton,
    BOverlay,
    BDropdown,
    BFormGroup,
    BFormTextarea,
    BDropdownItem,
    BFormInvalidFeedback,

    // validations
    ValidationProvider,
    ValidationObserver
  },
  mixins: [heightTransition],
  props: {
    consultationData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      presenting_complaint_history: this.consultationData.presenting_complaint_history
    }
  },
  computed: {
    disableForm(){
      return !this.can(`consultations:CanUpdate`)
    },
  },
  methods: {
    async onUpdate(){
      try {
        this.loading = true;
        this.errorMessage = "";

        const success = await this.$refs.form_ref.validate();
        if (!success){
          return;
        }

        if (!this.can(`consultations:CanUpdate`)) {
          return
        }

        await this.useJwt().mainService.consultations.update(this.consultationData.id, {
          presenting_complaint_history: this.presenting_complaint_history
        });

        this.$emit('refresh')

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            variant: 'success',
            icon: 'CheckCircleIcon',
            text: `Presenting complaint history updated successfully`
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    onDownload() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Error!',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
          text: 'This feature is not available yet.'
        },
      });
    }
  }
}
</script>

<style scoped>
.profile-highlight {
  font-size: 18px !important;
}
.profile-highlight-title {
  font-size: 16px !important;
  color: lightgray;
  font-weight: normal;
}

.patient-name {
  font-size: 25px;
}
</style>
